import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import CustomNavigate from "../components/CustomNavigate";

export default function EmailVerifiedMiddleware({ children, route = "/auth/email/verify" }) {
  const { user } = useAuth();

  if (!user?.emailVerified) return <CustomNavigate to={route} replace />;
  return children;
}

EmailVerifiedMiddleware.propTypes = {
  children: PropTypes.node.isRequired,
};